'use strict';

import React from 'react';
import styles from './loader.scss';

export default class Loader extends React.Component{
	render(){
		const styleObj = this.props.style || {};
		const className = this.props.className || "";
		let extraProps = {};
		if(this.props.id){
			extraProps.id = this.props.id;
		}
		return (
			<div
				className={`${styles["mobile-loader"]} ${className}`}
				{...extraProps}
				style={styleObj}
				onClick={(e) => {
					e.stopPropagation();
				}}
			>
				<div className={styles["svg-wrapper"]}>
					<div className={styles["circle"]}></div>
				</div>
			</div>
		)
	}
}